import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  FileNode,
  FileService,
  NodeType
} from '../../../services/file.service';
import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/angular';
import { FilesHelperService } from '../../../services/files-helper.service';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileListComponent {
  @Input() nodes: FileNode[] = [];
  @Input() prefix: string = '';
  @Input() currentShipmentDate?: string;

  orderId: number;
  isOpen = false;
  NodeType = NodeType;

  constructor(
    private fileService: FileService,
    private filesHelper: FilesHelperService
  ) {
    this.orderId =
      +window.location.pathname.split('/')[
        window.location.pathname.split('/').findIndex(el => el === 'days') + 1
      ];
  }

  async openDocument(node: FileNode) {
    this.isOpen = false;
    if (node.documentId) {
      try {
        const filePath = await this.fileService.downloadFileForDeal(
          Number(node.documentId),
          node.name,
          node.documentType,
          this.orderId,
          this.currentShipmentDate
        );
        if (filePath && Capacitor.isNativePlatform()) {
          const extension = node.name.toLowerCase().split('.').pop() || '';
          const mimeType = this.filesHelper.getMimeTypeFromExtension(extension);
          await this.filesHelper.openFile(filePath, mimeType);
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    }
  }

  async shareDocument(node: FileNode) {
    this.isOpen = false;
    if (node.documentId) {
      try {
        const filePath = await this.fileService.downloadFileForDeal(
          Number(node.documentId),
          node.name,
          node.documentType,
          this.orderId,
          this.currentShipmentDate
        );

        if (filePath && Capacitor.isNativePlatform()) {
          await this.filesHelper.shareFile(filePath, node.name);
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    }
  }

  /**
   * Получает дату отгрузки из текущего контекста или узла DATE
   */
  getShipmentDateForNode(node: FileNode): string | undefined {
    // Если это узел DATE, извлекаем дату из его имени
    if (node.nodeType === NodeType.DATE) {
      return node.name; // например, "26.05.2025"
    }

    // Если передана дата из родительского компонента
    if (this.currentShipmentDate) {
      return this.currentShipmentDate;
    }

    return undefined;
  }
}
